import React, { useState, useEffect } from "react";
import { X, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGlowStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <section data-section-id="21317" id="the-art-of-the-detail" className="dark bg-background text-foreground relative min-h-[100dvh] w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-t from-background via-black/40 to-transparent z-10" />
        <picture className="block h-full w-full">
          <source media="(max-width: 768px)" srcSet="https://ceedaydetailing.com/wp-content/uploads/2026/04/Hero-page-mobile.png" />          <img src="https://ceedaydetailing.com/wp-content/uploads/2026/04/Website-hero.png" alt="Ceeday Detailing Premium Automotive Service" className="h-full w-full object-cover object-center" />
        </picture>
      </div>

      {}
      <div className="relative z-20 flex min-h-[100dvh] flex-col items-center justify-center px-6 py-20 text-center">
        <div ref={ref} className={`max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-default text-4xl sm:text-5xl md:text-7xl lg:text-[80px] leading-[1.1] text-primary mb-6 tracking-tight font-bold">CEEDAY <span className="text-white">DETAILING</span></h1>
          <p className="font-sans text-lg md:text-xl text-white mb-10 max-w-2xl mx-auto font-light tracking-wide">Where automotive passion meets uncompromising craftsmanship. Your vehicle restored to its best form.</p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 sm:gap-6 w-full max-w-sm sm:max-w-none mx-auto">
            <Button asChild className="h-14 rounded-full px-10 text-base font-bold bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-2xl transition-all hover:scale-110 w-full sm:w-auto uppercase tracking-widest">
              <Link to="https://app.urable.com/virtual-shop/RwwACfmUUCbP7DfYZWTj/CGFL6U746Nrm4S5dIlSG">BOOK NOW</Link>
            </Button>
            <Button asChild variant="outline" className="h-14 rounded-full px-8 text-base font-medium bg-transparent border-white text-white hover:bg-white/10 hover:text-white transition-transform hover:scale-105 w-full sm:w-auto">
              <Link to="ServicesPage">OUR SERVICES</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      {showModal && <div className="fixed bottom-4 left-4 z-50 w-full max-w-[90vw] sm:max-w-md animate-in slide-in-from-bottom-10 fade-in duration-700">
          <div className="relative overflow-hidden rounded-xl bg-card shadow-2xl border border-border/50">
            {}
            

            {}
            

            {}
            
          </div>
        </div>}
    </section>;
}